var _path, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDumper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,15.3c-0.3-2.4-0.8-4-0.8-4l-5.2,0c-0.6,1.6-1,4-1,4H9.8c0.3-1.5-0.6-3.1-0.6-3.1l4.2,1.6l2-6.3H19 l-0.3,2.2h3.8v4.2h0.4l0.2,0.2v1l-0.2,0.2H21.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "20,7.1 15.1,7.1 13.2,13 1,8.9 1.9,7.4 13.1,7.4 13.9,6.4 20,6.4  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "12.9,12.5 1.6,8.9 2,8 2.5,8 2.2,8.7 3,9 3.4,8 3.7,8 3.6,9.1 5,9.5 5.6,8 6,8 5.4,9.7 6.9,10.1  7.7,8 8.2,8 7.4,10.3 8.9,10.7 9.9,8 10.4,8 9.4,10.9 10.8,11.4 12.1,8 12.5,8 11.3,11.6 12.9,12.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "17.9,7.8 17.9,9.7 18.4,9.7 18.6,7.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 7.8,
    style: {
      fill: "#000"
    },
    width: 1.5,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    style: {
      fill: "#000"
    },
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 14.5,
    style: {
      fill: "#000"
    },
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M3.3,14.6c0,1.7,1.4,3,3,3c1.7,0,3-1.4,3-3c0-1.7-1.4-3-3-3S3.3,12.9,3.3,14.6z M5.5,14.6c0-0.1,0-0.1,0-0.2 c0.1-0.4,0.4-0.7,0.9-0.7s0.8,0.4,0.9,0.7c0,0.1,0,0.1,0,0.2c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.1-0.4,0.2-0.6,0.2 c-0.3,0-0.4-0.1-0.6-0.2C5.5,15.1,5.4,14.8,5.5,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M14.7,14.6c0,1.7,1.4,3,3,3c1.7,0,3-1.4,3-3c0-1.7-1.4-3-3-3C16,11.6,14.7,12.9,14.7,14.6z M16.8,14.6 c0-0.1,0-0.1,0-0.2c0.1-0.4,0.4-0.7,0.9-0.7c0.4,0,0.8,0.4,0.9,0.7c0,0.1,0,0.1,0,0.2c0,0.3-0.1,0.5-0.3,0.7 c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0-0.4-0.1-0.6-0.2C16.9,15.1,16.8,14.8,16.8,14.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumper);
export default __webpack_public_path__ + "static/media/dumper.a8c00e46d39e35927ff37b5d2e0383a4.svg";
export { ForwardRef as ReactComponent };